<template>
  <div>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import Snotify, { SnotifyPosition } from 'vue-snotify';

import { SnotifyService } from 'vue-snotify/SnotifyService';

Vue.use(Snotify);

declare module 'vue/types/vue' {
  interface Vue {
    $snotify: SnotifyService;
  }
}

@Component({
  components: {}
})
export default class Notifications extends Vue {
  get error() {
    return this.$store.state.general.toastError;
  }

  get success() {
    return this.$store.state.general.toastSuccess;
  }

  get info() {
    return this.$store.state.general.toastInfo;
  }

  @Watch('error')
  private onPropertyChanged(value: any, oldValue: any) {
    if (value) {
      this.$snotify.error(value, {
        html: value,
        timeout: 3000,
        showProgressBar: false,
        pauseOnHover: true,
        icon: undefined,
        position: SnotifyPosition.leftBottom
      }).on(('shown'), () => {
        this.$store.commit('setToastError', undefined);
      });
    }
  }

  @Watch('info')
  private onInfoPropertyChanged(value: any, oldValue: any) {
    if (value) {
      this.$snotify.info(value, {
        html: value,
        timeout: 5000,
        showProgressBar: false,
        pauseOnHover: true,
        icon: undefined,
        position: SnotifyPosition.leftBottom
      }).on(('shown'), () => {
        this.$store.commit('setToastInfo', undefined);
      });
    }
  }

  @Watch('success')
  private onSuccessPropertyChanged(value: any, oldValue: any) {
    if (value) {
      this.$snotify.success(value, {
        html: value,
        timeout: 3000,
        showProgressBar: false,
        pauseOnHover: true,
        icon: undefined,
        position: SnotifyPosition.leftBottom
      }).on(('shown'), () => {
        this.$store.commit('setToastSuccess', undefined);
      });
    }
  }

}
</script>
